module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAMCAYAAABm+U3GAAAAAXNSR0IArs4c6QAAASZJREFUOBFjNDEx6fr//38pAxUBIyNjN/OzZ892S0tLywPNNaSG2UBD5585cyaHCWSYoqJiKlBgE6UGg8wAmQUyhxFmmIODA8eXL192AoPFDiZGCg009BAPD4/7gQMHfoD0wQ0GcYyNjfmB1EEg1gfxSQAXgWrtz549+xGmB8VgkKCpqakE0NVHgVgJpggfDXTpPSC2Pn369AtkdRgGgySBhitBDZdAVozOBhr4AmroPXQ5cOShCwJtv8fExOQBFId7DV0NSA6kBqQWixwDVoNBCk+dOnURqNEP6CJwZCBrBomB5EBqkMWR2TgNBikCuuYQkAoHGvQXpgnKDofKwYQxaGYMETQBYAa6CcxAj4BhHgCSAro0GZgBVqIpI58LzPqlIEysCQAT9mJDF0G9CwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/dk.png
// module id = 209
// module chunks = 0